import { API, Auth } from 'aws-amplify';

export const query = /* GraphQL */ `
  query GetTestsExecutions($service: String, $date: AWSDateTime) {
    getTestsExecutions(service: $service, date: $date) {
      ... on GetTestsExecutionsSuccess {
        __typename
        result {
          test_id
          e2e_execution_id
          title
          suite
          environment
          criticality
          brand
          error_category
          brand_importance
          service_brand_relevance
          error_frequency
          error_severity
          result
          started_at
          duration
          logs
          logsPresignedUrl
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export interface GetTestsExecutionsVariables {
  service?: string;
  // 2025-04-28T09:07:19.091Z
  date?: string
}

interface TestExecutionResult {
  test_id: string;
  e2e_execution_id: string;
  title: string;
  suite: string;
  environment: string;
  criticality: string;
  brand: string;
  error_category: string;
  brand_importance: string;
  service_brand_relevance: string;
  error_frequency: string;
  error_severity: string;
  result: string;
  started_at: string;
  duration: number;
  logs: string;
  logsPresignedUrl: string;
}

export interface GetTestsExecutionsSuccess {
  __typename: 'GetTestsExecutionsSuccess';
  result: TestExecutionResult[];
}

interface GraphQLResponse {
  __typename: string;
  message?: string;
  statusCode?: number;
  result?: TestExecutionResult[];
}

async function getTestsExecutionsService({
  service,
  date,
}: GetTestsExecutionsVariables): Promise<TestExecutionResult[]> {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query,
      variables: {
        service,
        date,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    }) as { data: { getTestsExecutions: GraphQLResponse } };

    if (!postData.data) {
      throw new Error('Internal Server Error');
    }

    const response = postData.data.getTestsExecutions;

    if (response.__typename === 'GetTestsExecutionsSuccess' && response.result) {
      return response.result;
    }

    throw new Error(response.message || 'Unknown error occurred');
  } catch (error: any) {
    console.error('Error in getTestsExecutions:', error);
    throw new Error(`Internal Server Error: ${error.errors ? error.errors[0].message : error.message}`);
  }
}

export default getTestsExecutionsService;